import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { ratioKeys } from "./query-keys";

export function useDeleteRatio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ sku }: { sku: string }) => {
      const { error } = await apiClient.DELETE("/v1/inventory-ratio/{sku}", {
        params: { path: { sku } },
      });
      if (error) throw error;
    },
    onSuccess: (_data, { sku }) => {
      void qc.invalidateQueries({ queryKey: ratioKeys.lists });
      void qc.invalidateQueries({ queryKey: ratioKeys.detail(sku) });
    },
  });
}
